export enum LineMeasurementConstraint {
  Free = 'free',
  ConstrainZ = 'constrainZ',
}
